interface ProductDetailFooterProps {
  description?: string | null;
  title: string;
}

export default function ProductDetailFooter({ description, title }: ProductDetailFooterProps) {
  const hasContent = (description ?? "").trim() !== "";

  return (
    <section className="mt-10 px-3 md:px-0">
      <div className="max-w-7xl  detail-card p-6">
        <div className="flex items-center justify-between gap-3 border-b border-slate-100 pb-4">
          <div>
            <p className="section-eyebrow">Thông tin chi tiết</p>
            <h3 className="text-xl font-bold text-slate-900">Giới thiệu {title}</h3>
          </div>
          <span className="chip text-xs bg-slate-100 text-slate-700">Nội dung đầy đủ</span>
        </div>

        <div className="detail-content pt-4">
          {hasContent ? (
            <div dangerouslySetInnerHTML={{ __html: description ?? "" }} />
          ) : (
            <p className="text-slate-600">Đang cập nhật nội dung sản phẩm.</p>
          )}
        </div>
      </div>
    </section>
  );
}
